<template>
  <div class="sections-label">
    <span class="fa fa-caret-left" />
    <span>{{ title }}</span>
  </div>
</template>

<script>

export default {
  name: 'MockSectionsLabel',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .sections-label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;

    .fa {
      width: 10px;
      color: $riseup_gray_1;
      vertical-align: middle;

      &.out-of-date {
        color: $riseup_gray_1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/components/types/MockSectionsLabel.vue